<script setup lang="ts">
import { ref, computed, inject } from "vue";
import { TranslationService } from "../services/translation.service";

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const { newsEntries, categories } = defineProps({
    newsEntries: {
        type: Array,
        required: true,
    },
    categories: {
        type: Array,
        required: true,
    },
});

const chosenCategory = ref("");

const allNewsLimit = ref(9);

const slicedNewsEntriesSidebar = computed(() => {
    return newsEntries.slice(0, allNewsLimit.value);
});

const slicedNewsEntries = computed(() => {
    return newsEntries
        .filter(
            (item) =>
                item.category === chosenCategory.value ||
                chosenCategory.value === "",
        )
        .slice(0, allNewsLimit.value);
});

const changeCategory = (category) => {
    // Implement the logic to change the category
    chosenCategory.value = category;
};

const generateUrl = () => {
    // Implement the logic to generate the URL based on site handle and item ID
    return `test`;
};

const loadMore = () => {
    allNewsLimit.value = allNewsLimit.value + 9;
};
</script>

<template>
    <div class="col-start-3 col-end-23">
        <div class="mb-12 mt-12">
            <ul class="flex gap-8 border-b border-grey-200">
                <li
                    class="border-b-4 border-transparent px-2 py-2 cursor-pointer"
                    v-for="(item, index) in categories"
                    :class="{ '!border-primary': chosenCategory === item.slug }"
                    @click="changeCategory(item.slug)"
                >
                    <span>
                        {{ item.title }}
                    </span>
                </li>
            </ul>
        </div>
    </div>

    <div class="col-start-3 col-end-23">
        <div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-12">
            <a
                class="home-news-link"
                :href="item.url"
                v-for="item in slicedNewsEntries"
            >
                <div class="corner-tag-large">
                    <span class="tag">{{ item.categoryTitle }}</span>
                </div>

                <div class="home-news-body">
                    <img
                        class="wide-img"
                        :src="item.mainImage"
                        :alt="item.title"
                    />

                    <div class="news-category bg-primary">
                        {{ item.postDate }}
                    </div>

                    <div class="news-title">{{ item.title }}</div>
                    <div class="news-lead">{{ item.lead }}</div>
                </div>

                <div class="home-news-learnmore">
                    Learn more
                    <i class="fas fa-arrow-right"></i>
                </div>
            </a>
        </div>

        <button
            class="btn-cb mt-12"
            @click="loadMore()"
            v-if="newsEntries.length > slicedNewsEntries.length"
        >
            Load more <i class="fas fa-arrow-right"></i>
        </button>
    </div>
</template>
